import { StageLayer } from '@nolimitcity/slot-launcher/bin/StageLayer';
import { Beheaded } from '../../Beheaded';
import { gsap } from 'gsap';
import { SpinePlayer } from '../../../core/displayobject/SpinePlayer';
import { Helper } from '../../../core/utils/Helper';

export enum BGType {
    MAIN = 'backgroundAnim',
    OVERLAY = 'backgroundTopAnim',
    COULDRON_BACK = 'couldronBack',
    COULDRON_FRONT = 'couldronTop',
}

export class Background extends PIXI.Container implements StageLayer {
    private _background: SpinePlayer;

    private _currentBGLevel:number = 0;
    public get currentBGLevel():number{
        return this._currentBGLevel;
    }

    constructor() {
        super();
        this.init();
    }

    protected init(): void {

         // lvl_0-5_start ,loop, end
        // base background
        this._background = this.addChild(new SpinePlayer(BGType.MAIN));
        this._background.play({animation:"lvl_0_loop",loop:true});
        this._background.position.set(346, 1150);
    }

    public upgradeBG(level: number){
        
        if(this._currentBGLevel == level) return;

        const loopAnimName: string = 'lvl_' + level + '_loop';
        const startAnimName: string = 'lvl_' + level + '_loop';
        const endAnimName: string = 'lvl_' + level + '_loop';

        if(this._currentBGLevel > level){
            this._background.play({animation:endAnimName,showOnEnd:true,onComplete:() => {
                this._background.play({animation:loopAnimName,loop:true});
            }})
        }else{
            this._background.play({animation:startAnimName,showOnEnd:true, onComplete:() => {
                this._background.play({animation:loopAnimName,loop:true});
            }})
        }

        Beheaded.backgroundCharacter.upgradeBG(level)

        this._currentBGLevel = level;
    }
}
